export default __webpack_public_path__ + "static/media/9.0b4dc770.webp";